import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "license-page-tab-view-intervals-list-item-date label-mono-m",
    textContent: _toDisplayString(_ctx.content)
  }, null, 8, _hoisted_1))
}